import CurrencyService from '../../../services/CurrencyService';
import MutationService from '../../../services/MutationService';
import RaffleService from '../../../services/RaffleService';
import style from './styles/RaffleInfo.scss';
import RouteHelper from '../../../helpers/RouteHelper';
import {EU_COUNTRIES} from '../../../enums/Countries';

const RaffleInfo = ({ raffle, sizeId, sex, activeStep, deliveryService, selectedCountry }) => {
	const currency = CurrencyService.getCurrency();
	let size = raffle.getSize(sizeId);
	// Size id can get changed before
	if (!size) {
		size = { id: '', us: '', eur: '', uk: '', cm: '', pieces: 0 };
	}

	const mutationCode = MutationService.getMutationCode();
	return (
		<div className={`row ${style['raffle-info']} ${activeStep.value.toLowerCase() + '-step'}`}>
			<div className={`col-sm-12 col-md-auto p-0 ${style['raffle-info-image']}`}>
				<img className={style.raffle} src={RaffleService.getImageUrl(raffle.getMainImage())} />
			</div>
			<div className={`col-sm-12 col-md-auto ${style['raffle-info-text']}`}>
				<h4 className={style.brand}>{raffle.brand}</h4>
				<span className={style.name}>
					{raffle.getTitle(mutationCode)}
					<PriceWithCurrencyBlock {...{ raffle, currency }} />
				</span>
				<span className={style.type}>
					{raffle.getSubtitle(mutationCode)}
					<ShippingBlock {...{ deliveryService, selectedCountry }} />
				</span>
				<span className={style.size}>
					<span className={style.sizeLabel}>Size</span>&nbsp;
					<span className={style.sizeValue}>EUR {size.eur} / {sex}</span>
				</span>
			</div>
		</div>
	);
};

const ShippingLink = ({ children }) => (
	// eslint-disable-next-line react/jsx-no-target-blank
	<a href={RouteHelper.getUrl('/shipping')} rel="norefferer noopener" target="_blank">
		{children}
	</a>
);

const ShippingBlock = ({ deliveryService, selectedCountry }) => {
	const isEU = EU_COUNTRIES.includes(selectedCountry);

	return (
		<span className={style.shipping}>
			{deliveryService ? (
				<span className={style.shipping}>+ Shipping {CurrencyService.format(deliveryService.price)}</span>
			) : (
				<ShippingLink><span>+ Shipping</span></ShippingLink>
			)}
			{!isEU && (
				<ShippingLink><span>+ duty</span></ShippingLink>
			)}
		</span>
	);
};

const PriceWithCurrencyBlock = ({ raffle, currency }) => (
	<span className={style.currency}>
		<span className={style.currencyCode}>{currency.symbolBefore}</span>&nbsp;
		<span className={style.price}>{CurrencyService.round(raffle.getPrice(currency.code))}</span>&nbsp;
		<span className={style.currencyCode}>{currency.symbolAfter}</span>
	</span>
);

export default RaffleInfo;


// WEBPACK FOOTER //
// ./components/blocks/raffleForm/RaffleInfo.js